module.exports = __webpack_public_path__ + "media/images/crosswords/p4-428076aa1c3cb1376e97a27d010c3c3a.png";